<template>
  <div>
	  <Header :sel='6' @changePhone="changePhone"/>
	  <div :class="['cd-main-content',showPhone?'nav-is-visible':'']">
	    <!-- your content here --> 
	    <!--banner-->
	    <div class="banner">
	      <div class="banner_txt">
	        <p><strong>Contact Us</strong></p>
	        <p>联系我们</p>
	      </div>
	    </div>
	    <!--banner--> 
	    
	    <!--neirong-->
	    <div class="neirong"> 
	      <!--left-->
	      
	      <div class="bread"> <a href="javascript:void(0)" @click="go('/')">首页</a> - <a href='javascript:void(0)'>联系我们</a></div>
	  
	      
	      <div class="neirong_c">
	  
	         <div class="contact_l fl" v-html="companyData.cmsArticleData?companyData.cmsArticleData.content:''">
	            
	           
	          </div>
	         <div class="contact_r fr">
	           <img :src="companyData.image" /> 
	          </div>
	  
	          
	          <div class="clear"></div>
	          
	        </div>
	    </div>
		 <Footer></Footer>
		</div>
	  
   
  </div>
</template>

<script>
	import Header from '@/components/header.vue'
	import Footer from '@/components/footer.vue'
	import{articleDetail} from '@/api/reqFetch.js'
  export default {
  	name: '',
    layout: '',
	components: {
	  Footer,
	  Header
	},
  	data() {
  		return {
			
			list:[],
			pageNumber: 1,
			indexs: [],
			totalPage: 0,
			showPhone:false,
			companyData:{}
		}
  	},

  	mounted() {
		articleDetail({id:'1665619318473502720'}).then(res => {
		    this.companyData = res.data;
		});
  	  //this.getData()
  	},

  	methods: {
		go(url){
			if(this.$route.fullPath!=url){
				this.$router.push(url)
				
			}
		},
		changePhone(val){
			this.showPhone=val
		},
		checkIndex() {
		    var left = 1;
		    var right = this.totalPage;
		    var ar = [];
		    if (this.totalPage >= 3) {
		        if (this.pageNumber > 1 && this.pageNumber < this.totalPage - 2) {
		            left = this.pageNumber - 1
		            right = this.pageNumber + 1
		        } else {
		            if (this.pageNumber <= 1) {
		                left = 1
		                right = 3
		            } else {
		                right = this.totalPage
		                left = this.totalPage - 2
		            }
		        }
		    }
		    while (left <= right) {
		        ar.push(left)
		        left++
		    }
		    this.indexs = ar
		
		},
		goPage(type) {
		    if (type == 'home') {
		        this.pageNumber = 1
		    } else if (type == 'end') {
		        this.pageNumber = Number(this.totalPage)
		
		    } else if (type == 'last') {
		        if (this.pageNumber > 1) {
		            this.pageNumber = this.pageNumber - 1
		        }
		    } else if (type == 'next') {
		        if (this.pageNumber < (this.totalPage)) {
		            this.pageNumber = this.pageNumber + 1
		        }
		    } else {
		        this.pageNumber = type
		    }
		    
		},
		
		
     
  	}
  }
</script>

<style scoped>
	/* .banner{
		background-image: url('../../assets/images/banner_06.png');
	} */
</style>
